var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 30,
    viewBox: "0 0 51 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 15C17.6961 15 20.5 12.1961 20.5 8.75C20.5 5.30391 17.6961 2.5 14.25 2.5C10.8039 2.5 8 5.30391 8 8.75C8 12.1961 10.8039 15 14.25 15ZM41.75 5H24.25C23.5594 5 23 5.55937 23 6.25V17.5H5.5V1.25C5.5 0.559375 4.94063 0 4.25 0H1.75C1.05937 0 0.5 0.559375 0.5 1.25V28.75C0.5 29.4406 1.05937 30 1.75 30H4.25C4.94063 30 5.5 29.4406 5.5 28.75V25H45.5V28.75C45.5 29.4406 46.0594 30 46.75 30H49.25C49.9406 30 50.5 29.4406 50.5 28.75V13.75C50.5 8.91719 46.5828 5 41.75 5Z",
    fill: "#1378A5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBed);
export default __webpack_public_path__ + "static/media/bed.fcebcd68801847e8d6bd4974344dab91.svg";
export { ForwardRef as ReactComponent };